/* tslint:disable */
/* eslint-disable */
/**
 * CyberWell Aegis API
 * Multi-tenant case management API with JWT auth, RBAC (Casbin), audit logging, and tenant isolation.
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * Response for role assignment operations
 * @export
 * @interface RoleAssignmentResponse
 */
export interface RoleAssignmentResponse {
    /**
     * Number of roles assigned
     * @type {number}
     * @memberof RoleAssignmentResponse
     */
    assignedCount?: number;
    /**
     * Number of roles revoked
     * @type {number}
     * @memberof RoleAssignmentResponse
     */
    revokedCount?: number;
    /**
     * List of assigned role IDs
     * @type {Array<string>}
     * @memberof RoleAssignmentResponse
     */
    assignedRoleIds?: Array<string>;
    /**
     * List of revoked role IDs
     * @type {Array<string>}
     * @memberof RoleAssignmentResponse
     */
    revokedRoleIds?: Array<string>;
    /**
     * Indicates if the request was successful
     * @type {boolean}
     * @memberof RoleAssignmentResponse
     */
    success?: boolean;
    /**
     * Error message if the request failed
     * @type {string}
     * @memberof RoleAssignmentResponse
     */
    error?: string;
}

/**
 * Check if a given object implements the RoleAssignmentResponse interface.
 */
export function instanceOfRoleAssignmentResponse(value: object): value is RoleAssignmentResponse {
    return true;
}

export function RoleAssignmentResponseFromJSON(json: any): RoleAssignmentResponse {
    return RoleAssignmentResponseFromJSONTyped(json, false);
}

export function RoleAssignmentResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): RoleAssignmentResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'assignedCount': json['assignedCount'] == null ? undefined : json['assignedCount'],
        'revokedCount': json['revokedCount'] == null ? undefined : json['revokedCount'],
        'assignedRoleIds': json['assignedRoleIds'] == null ? undefined : json['assignedRoleIds'],
        'revokedRoleIds': json['revokedRoleIds'] == null ? undefined : json['revokedRoleIds'],
        'success': json['success'] == null ? undefined : json['success'],
        'error': json['error'] == null ? undefined : json['error'],
    };
}

export function RoleAssignmentResponseToJSON(json: any): RoleAssignmentResponse {
    return RoleAssignmentResponseToJSONTyped(json, false);
}

export function RoleAssignmentResponseToJSONTyped(value?: RoleAssignmentResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'assignedCount': value['assignedCount'],
        'revokedCount': value['revokedCount'],
        'assignedRoleIds': value['assignedRoleIds'],
        'revokedRoleIds': value['revokedRoleIds'],
        'success': value['success'],
        'error': value['error'],
    };
}

